import MapWrapper from '../../map-wrapper';
import LocationFilters from '../../location-filters';
import NewIekLocationFilters from './location-filters';
import './style.scss';
import Select from './select';
import { useContext } from 'react';
import { StoresContext } from '../../../App';
import { useDebouncedSearch } from '../../../util/misc';
import StoreCards from '../../store-cards';
import StoreList from './store-list';

const features = {
    Special: 'Специализированный магазин',
    DIY: 'DIY',
    WebStore: 'Интернет магазин',
    Wholesale: 'Оптовые продажи',
    PanelAssembly: 'Сборщик',
};
const featureOptions = Object.entries(features).map(([code, name]) => ({
    name,
    value: { code, value: null },
}));

export default function NewIek() {
    const { featureFilters, setFeatureFilters, article, filterStock, setFilterStock } =
        useContext(StoresContext);
    const selectedFeature = features[featureFilters[0]?.code as keyof typeof features] || '';
    const search = useDebouncedSearch();
    return (
        <section className="where-buy new-iek">
            <div className="wrap">
                <div className="container">
                    <div className="container-content container-content--w100">
                        <div className="partners map-container">
                            <h1 className="where-to-buy__title">
                                Где купить {article ? `«${article}»` : ''}
                            </h1>
                            <div className="partners-select marketnavigator-filters">
                                <LocationFilters render={NewIekLocationFilters} />
                                <div className="partners-select-item">
                                    <Select
                                        name="Тип партнера"
                                        value={selectedFeature}
                                        options={featureOptions}
                                        onChange={(val) => setFeatureFilters(val ? [val] : [])}
                                    />
                                </div>
                            </div>

                            <MapWrapper className="partners-map" />
                            <div className="partners-search">
                                <div className="ui-search ui-search--big">
                                    <div className="ui-input">
                                        <input
                                            className="ui-input__control ui-input__control--big ui-input__control--gray"
                                            placeholder="Введите название партнера, город или улицу для поиска"
                                            onInput={search}
                                        />
                                        <button type="button" className="ui-search__button">
                                            <i className="icon-search" />
                                        </button>
                                    </div>
                                    {article && (
                                        <div className="ui-input filter-checkboxes">
                                            <label className="ui-checkbox iek-prodcat-catalog-section-filter-values__value-wrap">
                                                <input
                                                    className="ui-checkbox__control"
                                                    type="checkbox"
                                                    checked={filterStock}
                                                    onChange={(e) => setFilterStock(e.target.checked)}
                                                />
                                                <span className="ui-checkbox__icon" />
                                                <span className="ui-checkbox__text">Только с товаром</span>
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <StoreCards render={StoreList} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
